<template>
    <div class="body fixed mobile">
        <!-- class: fixed, mobile -->
        <!-- Loading Spinner -->
        <!-- <div class="spinner"><div><div></div></div></div> -->
        <!-- Header -->
        <section class="header profile_edit">
            <div class="flexH width">
                <a
                    class="icon iconButton third"
                    @click.prevent="$router.push('/profile')"
                >
                    <font-awesome-icon icon="fa-solid fa-chevron-left" size="lg"></font-awesome-icon>
                </a>
            </div>
            <span class="fL nowrap">編輯個人資料</span>
            <div class="flexH width right"></div>
        </section>
        <!-- Main -->
        <section class="main profile_edit">
            <div class="info flexV width padding center">
                <a class="img" v-if="displayUserImage"><img :src="displayUserImage" /></a>
                <a class="img" v-else><img src="@/assets/img/profile-d.png" /></a>
                <div class="input rounded">
                    <!-- class: error -->
                    <div class="icon"><font-awesome-icon icon="fa-solid fa-user"></font-awesome-icon></div>
                    <span class="fM nowrap gray">姓名</span>
                    <input
                        type="text"
                        class="fM"
                        placeholder=""
                        v-model="userData.name"
                    />
                    <!-- <span class="fS error message">必填</span> -->
                </div>
                <div class="dropdown rounded">
                    <div class="icon">
                        <font-awesome-icon icon="fa-solid fa-venus-mars"></font-awesome-icon>
                    </div>
                    <span class="fM nowrap gray">性別</span>
                    <select
                        name="type"
                        class="fM rounded"
                        dir="rtl"
                        v-model="userData.gender"
                    >
                        <option
                            v-for="(gender, index) in genderType"
                            :key="'gender' + index"
                            :value="gender.value"
                        >
                            {{ gender.text }}
                        </option>
                    </select>
                    <div class="arrow">
                        <font-awesome-icon icon="fa-solid fa-caret-down" size="xs"></font-awesome-icon>
                    </div>
                </div>
                <div class="input rounded birth">
                    <!-- class: error -->
                    <div class="icon"><font-awesome-icon icon="fa-solid fa-calendar"></font-awesome-icon></div>
                    <span class="fM nowrap gray">生日</span>
                    <input class="fM date" type="date" v-model="userData.birthdate" />
                    <span class="fS error message">必填</span>
                </div>
                <div class="input rounded">
                    <!-- class: error -->
                    <div class="icon"><font-awesome-icon icon="fa-solid fa-id-card"></font-awesome-icon></div>
                    <span class="fM nowrap gray">地址</span>
                    <input
                        type="text"
                        class="fM"
                        placeholder=""
                        v-model="userData.fullAddress"
                    />
                    <!-- <span class="fS error message">必填</span> -->
                </div>
                <div class="input rounded disabled">
                    <!-- class: error -->
                    <div class="icon"><font-awesome-icon icon="fa-solid fa-id-card"></font-awesome-icon></div>
                    <span class="fM nowrap gray">身分證字號</span>
                    <input
                        type="text"
                        class="fM"
                        placeholder=""
                        v-model="userData.idno"
                    />
                    <!-- <span class="fS error message">必填</span> -->
                </div>
                <div class="input rounded disabled">
                    <!-- class: error -->
                    <div class="icon"><font-awesome-icon icon="fa-solid fa-phone"></font-awesome-icon></div>
                    <span class="fM nowrap gray">手機號碼</span>
                    <input
                        type="text"
                        class="fM"
                        placeholder=""
                        v-model="userData.phoneNumber"
                    />
                    <!-- <span class="fS error message">必填</span> -->
                </div>
                <div class="input rounded">
                    <!-- class: error -->
                    <div class="icon"><font-awesome-icon icon="fa-solid fa-envelope"></font-awesome-icon></div>
                    <span class="fM nowrap gray">信箱</span>
                    <input
                        type="text"
                        class="fM"
                        placeholder=""
                        v-model="userData.email"
                    />
                    <!-- <span class="fS error message">必填</span> -->
                </div>
                <a class="button rounded" @click.prevent="save()">
                    <div class="icon">
                        <font-awesome-icon icon="fa-solid fa-floppy-disk"></font-awesome-icon>
                    </div>
                    <span class="fM">儲存</span>
                    <!-- 提交申請 -->
                </a>
            </div>
        </section>
        <!-- Popup (已儲存) -->
        <section id="popSuccess" class="popup">
            <div class="popBody">
                <section class="popHeader">
                    <!-- <span class="fL">Title</span> -->
                </section>
                <section class="popMain">
                    <div class="icon success">
                        <font-awesome-icon icon="fa-solid fa-circle-check" size="2x"></font-awesome-icon>
                    </div>
                    <span class="fL">已儲存</span>
                </section>
                <section class="popFooter">
                    <a
                        class="button submit rounded"
                        @click.prevent="popClose()"
                    >
                        <span class="fM">確定</span>
                    </a>
                </section>
            </div>
        </section>
    </div>
</template>
<script>
import { mapState } from "vuex";

export default {
    name: "ProfileEdit",
    data() {
        return {
            apiHost: process.env.VUE_APP_API_HOST,
            merchantId: process.env.VUE_APP_MERCHANT_ID,
            genderType: [
                {
                    value: 0,
                    text: "男"
                },
                {
                    value: 1,
                    text: "女"
                }
            ],
            userData: {
                name: "",
                gender: "",
                birthdate: "",
                idno: "",
                phoneNumber: "",
                email: "",
                fullAddress: ""
            }
        };
    },
    beforeRouteEnter(to, from, next) {
        // called before the route that renders this component is confirmed.
        // does NOT have access to `this` component instance,
        // because it has not been created yet when this guard is called!
        console.log(to, from);
        next((vm) => {
            let that = vm;
            if (that.user && that.user.userId) {
                //
            } else {
                next("/error");
            }
        });
    },
    computed: {
        ...mapState(["user", "userInfo"]),
        displayUserImage() {
            return this.userInfo ? this.userInfo.picture : "";
        }
    },
    mounted() {
        this.getUserData();
    },
    methods: {
        dummyUserData() {
            let result = {
                "memberId": 47,
                "uuid": null,
                "oauthId": "U38a079aadef4a60ec5a6263112248b35",
                "picture": "https://profile.line-scdn.net/0hNwmZpXdREVhQIzrAyWRuD2xmHzUnDRcQKEJdOHIlGmt1RFIHOEFXPSUiH2x4EFIHaBZebiErSW4p",
                "idno": "H223292882",
                "name": "Kay Lai",
                "birthdate": "1988-03-05",
                "phoneNumber": "0921185084",
                "carrier": null,
                "gender": 1,
                "email": "clearsky0305@gmail.com",
                "fullAddress": "桃園市平鎮區",
                "isTyCitizen": 1,
                "createdTs": 1647945287
            }
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve({data: result});
                }, 300);
            })
        },
        callUserDataAPI() {
            var config = {
                method: 'get',
                url: `${this.apiHost}/identities/v1/merchants/${this.merchantId}/members/${this.user.userId}`,
                headers: { }
            };

            return this.$http(config)
                .then(function (response) {
                    console.log(JSON.stringify(response.data));
                    return response;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getUserData() {
            this.callUserDataAPI()
            // this.dummyUserData()
            .then(res => {
                this.userData = res.data;
            })
            .catch(err => {
                console.log("err: ", err);
                this.$router.push('/error');
            })
        },
        popSuccess() {
            var popSuccess = document.getElementById("popSuccess");
            popSuccess.style.display = "flex";
        },
        popClose() {
            var popSuccess = document.getElementById("popSuccess");
            popSuccess.style.display = "none";
        },
        callUpdateProfileAPI() {
            // let response = {
            //     data: {
            //         result: "success"
            //     }
            // };
            // let promise = new Promise((resolve) => {
            //     setTimeout(() => {
            //         resolve(response);
            //     }, 300);
            // });
            // return promise;

            // let data = JSON.stringify(Object.assign({}, this.data));
            let data = Object.assign({}, this.userData);
            let config = {
                url: `${this.apiHost}/identities/v1/merchants/${this.merchantId}/members/${this.user.userId}`,
                method: "PUT",
                data: data
            }
            console.log("config: ", config)
            return this.$http(config);
        },
        save() {
            this.callUpdateProfileAPI()
                .then((res) => {
                    console.log("res: ", res);
                    this.popSuccess();
                })
                .catch((err) => {
                    console.log("err: ", err);
                });
        }
    }
};
</script>

